import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';

export const QuestionSummary = styled.div`
  position: relative;
  padding: 0 0 12px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  margin-bottom: 30px;

  &:first-of-type {
    padding-top: 24px;
  }

  h4 {
    max-width: ${grid(6)}px;
  }
`;
